import axios from 'axios';
import { REACT_APP_API } from '../../config';

export async function answerMeliQuestion(body){
    try {
        const data = await axios.post(`${REACT_APP_API}/publications/meli/answerQuestion`,body) 
        return data?.data
    } catch (error) {
        throw new Error(error)
    }
}